const IMAGE_URL_RE = /^https?:\/\/.+\.(jpg|jpeg|png|gif|webp|svg|bmp|ico|avif)(\?.*)?$/i

export function isImageContent(content: string): boolean {
  return content.startsWith('data:image/') || IMAGE_URL_RE.test(content.trim())
}
